<template>
  <div class="document-request-ea-show-step2">

    <MainFormRequestShow :type="type" />
    <v-col cols="12"></v-col>
    <MainFormTrialStayOptionalShow :type="type" />
  </div>
</template>

<script>
import C from '@/utils/constant'
import { mapState } from 'vuex'
import MainFormRequestShow from '@/components/common/ShowDataStep2/MainFormRequestShow'
import MainFormTrialStayOptionalShow from '@/components/documentRequest/trialStay/MainFormTrialStayOptionalShow'

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  components: {
    MainFormTrialStayOptionalShow,
    MainFormRequestShow
  },
  mounted () {
  },
  computed: {
    ...mapState({
      // Format [stageName] => state.[modulesName].[stageName],
      dataTrialStay: state => state.documentRequest.dataTrialStay
    }),
    constant () {
      return Object.assign({}, C)
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.mt-30 {
  margin-top: 30px;
}
</style>
